import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @param data
 * @returns {Promise<AxiosResponse<*>>}
 * @constructor
 */
const GetDirectorsRequest = (data: any[] = {}): Promise<AxiosResponse<any>> =>
    Request.get(`/employers/get-directors?${Request.parseParams(data)}`);

/**
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export default GetDirectorsRequest;